import { render, staticRenderFns } from "./ValidationErrors.vue?vue&type=template&id=148d863d&scoped=true&"
import script from "./ValidationErrors.vue?vue&type=script&lang=ts&"
export * from "./ValidationErrors.vue?vue&type=script&lang=ts&"
import style0 from "./ValidationErrors.vue?vue&type=style&index=0&id=148d863d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148d863d",
  null
  
)

export default component.exports